import { FCX, ID } from "@datassential/platform-ui-lib";
import cn from "classnames";

interface MoreLabelProps {
    rowId: ID;
    count: number;
    isHighlighted: boolean;
}

const MoreLabel: FCX<MoreLabelProps> = ({ rowId, count, isHighlighted }) => {
    const text = `and ${count} more`;
    
    return (
        <span 
            className={cn("MacsList__more-label", { "is-highlighted": isHighlighted })}
            data-tooltip-id={`macs-list-table-item-description-${rowId}`}
        >
            {text}
        </span>
    );
};

export default MoreLabel;